import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, CheckCircle2, ArrowRight, RefreshCw } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export default function SignUpSuccess() {
  const navigate = useNavigate();

  const handleResendEmail = async () => {
    try {
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email: (await supabase.auth.getUser()).data.user?.email
      });
      
      if (error) throw error;
      
      toast.success('Verification email resent!');
    } catch (error) {
      toast.error('Failed to resend verification email');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-b from-background to-muted">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center space-y-4">
          <div className="flex justify-center">
            <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
              <CheckCircle2 className="h-8 w-8 text-primary" />
            </div>
          </div>
          <CardTitle className="text-2xl">Check your email</CardTitle>
          <CardDescription className="text-base">
            We've sent you a verification link to complete your registration
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-4">
            <div className="flex items-start gap-3 text-sm text-muted-foreground">
              <Mail className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
              <p>
                Click the link in your email to verify your account and start using BinauralFlow
              </p>
            </div>
            <div className="flex items-start gap-3 text-sm text-muted-foreground">
              <CheckCircle2 className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
              <p>
                After verification, you'll have access to all premium features including AI-powered recommendations
              </p>
            </div>
          </div>
          <div className="space-y-2">
            <p className="text-sm font-medium">Didn't receive the email?</p>
            <div className="flex gap-2">
              <Button 
                variant="outline" 
                className="flex-1"
                onClick={handleResendEmail}
              >
                <RefreshCw className="mr-2 h-4 w-4" />
                Resend email
              </Button>
              <Button 
                variant="outline" 
                className="flex-1"
                onClick={() => navigate('/auth/signin')}
              >
                Try signing in
              </Button>
            </div>
          </div>
          <Button 
            className="w-full" 
            onClick={() => navigate('/')}
          >
            Return to Home
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
} 